import { useState, useEffect } from "react"
import { Flex, Input, Modal, Form, DatePicker, List, Button } from "antd"
import ProgramStepper from "../ProgramStepper"
import { useTranslation } from "react-i18next"
import { fetchFaultCodes, restoreFaultcodes } from "../../../api/Cards"

export const FaultCodesModal = ({ onClose, metaData }) => {

    const handleClose = () => onClose()

    const handleCancel = () => handleClose()
    const { t } = useTranslation()
    const [faultCodes, setFaultCodes] = useState([])

    useEffect(() => {

        async function loadFaultCodes() {
            const data = await fetchFaultCodes(metaData)

            if (typeof data == "number") {
                console.log("gone offline")
                return
            }

            setFaultCodes(data)
        }

        loadFaultCodes()

    }, [])

    function restoreFaults() {
        restoreFaultcodes(metaData)
        setFaultCodes([])
    }
    

    return (
        <Modal footer={null} width={'635px'} minHeight={'300px'} onCancel={handleCancel} cancelText="Stäng" open>
            <List header={<div>{t("page.card-details.faultcodes")}</div>} footer={<div></div>}>
                {
                    faultCodes.map((fcode, i) => 
                        (<List.Item key={i}>{fcode}</List.Item>)
                    )
                }
                    
            </List>
            <Flex style={{ justifyContent: "center", flexDirection: "row", flexWrap: "wrap" }}><Button onClick={restoreFaults}>{t("page.card-details.faultcodes.clear")}</Button></Flex>
        </Modal>
    )
}
export default FaultCodesModal